import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import './AdminPortal.css';

const AdminPortal = () => {
    const navigate = useNavigate();

    
      const [activeButton, setActiveButton] = useState(null);
      
      const handleButtonClick = (button) => {
        setActiveButton(button);
        console.log(`${button} clicked`);
        if (button==="Get a Quote"){
          navigate("/subcontractform")
        }
        if (button==="Drive For Us"){
          navigate("/DriveDetail")
        }
        if (button==="Contact US"){
          navigate("/LogisticContact")
        }
    
      };

    const addcar=()=>{
        navigate("/Admin/AdminPortal/AddCar")
    }
    const reviewcar=()=>{
        navigate("/Admin/AdminPortal/CarReview")
    }
    const deledcar=()=>{
        navigate("/Admin/AdminPortal/DeleteCar")
    }
    const addadmin=()=>{
        navigate("/Admin/AdminPortal/AddAdmin")
    }
    const addFeatures=()=>{
        navigate("/Admin/AdminPortal/AddWhyus")
    }
    const delFeatures=()=>{
        navigate("/Admin/AdminPortal/DeleteFeatures")
    }
    const delReview=()=>{
        navigate("/Admin/AdminPortal/DeleteReviews")
    }
    const changetime=()=>{
        navigate("/Admin/AdminPortal/Timings")
    }
    // Handle logout functionality
    const handleLogout = () => {
        // Clear the authentication token
        localStorage.removeItem('authToken');
        
        navigate('/Admin');
        
    };

    return (
        <>
        <h1 style={{marginTop:'100px'}}>Welcome to Admin Portal</h1>
        <div className="admin-portal">
            
            <button className='contact-button' onClick={addcar}> Add Car</button>
            <button className='contact-button'  onClick={reviewcar}> Review Vehicles</button>
            <button className='contact-button' onClick={deledcar}> Delete/Edit Car</button>
            <button className='contact-button' onClick={addadmin}> Add Admin</button>
            <button className='contact-button' onClick={addFeatures}> Add Features</button>
            <button className='contact-button' onClick={delFeatures}> Delete Features</button>
            <button className='contact-button'onClick={delReview}> Delete Reviews</button>
            <button className='contact-button' onClick={changetime}> Change Timings</button>
            <button className='contact-button' onClick={handleLogout}
        style={{backgroundColor:'blue'}}
        
        > LogOut</button>
            
        </div>
        
        </>
    );
};

export default AdminPortal;
